import React from "react";
import { Box, Typography } from "@mui/material";
import OfferBox from "./OfferBox";

export default function OfferRow({ bankName, offers }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        border: "1px solid",
        borderColor: "common.white",
        borderRadius: 2,
        bgcolor: "grey.900",
        p: 2,
      }}
    >
      <Typography variant="subtitle2" color="text.secondary">
        {bankName} Offers
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
          },
          gap: 2,
        }}
      >
        {offers.map((offer, idx) => (
          <OfferBox key={idx} offer={offer} />
        ))}
      </Box>
    </Box>
  );
}
